export function getScoreLabel(score, type) {
  if (score === null || score === undefined) return '';

  if (type === 'walk') {
    if (score >= 90) return 'Very Walkable';
    if (score >= 70) return 'Walkable';
    if (score >= 50) return 'Somewhat Walkable';
    return 'Not Walkable';
  }

  if (type === 'bike') {
    if (score >= 90) return 'Very Bikeable';
    if (score >= 70) return 'Bikeable';
    if (score >= 50) return 'Somewhat Bikeable';
    return 'Not Bikeable';
  }

  if (type === 'transit') {
    if (score >= 90) return 'Excellent Transit';
    if (score >= 70) return 'Good Transit';
    if (score >= 50) return 'Fair Transit';
    return 'Poor Transit';
  }

  return '';
}
